import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F3F4F6] flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white p-8 border border-slate-200 rounded-md text-center">
        <XCircle className="w-16 h-16 text-[#E32636] mx-auto mb-4" />
        <h1 className="text-2xl font-black mb-2">Payment Cancelled</h1>
        <p className="text-slate-600 mb-6">
          Your payment was cancelled. No charges have been made.
        </p>
        <button
          onClick={() => navigate('/student')}
          className="px-6 py-3 bg-[#002FA7] text-white font-bold rounded-md hover:bg-[#001a5c]"
          data-testid="back-to-dashboard-button"
        >
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
